import { FormGroup } from '@angular/forms';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'irembogov-input-error',
  templateUrl: './input-error.component.html',
  styleUrls: ['./input-error.component.scss'],
})
export class InputErrorComponent {
  @Input() formName: FormGroup | undefined;
  @Input() inputName = '';
  @Input() errorName = '';
  @Input() errorMessage = '';
}
